import ColisScanner from "@/components/colis/ColisScanner";
import RequestReturnCrationDialog from "@/components/dialogs/RequestReturnCreationConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import { NavigationRoutes } from "@/components/navigation/constants";
import { Toaster } from "@/components/ui/toaster";
import { DialogType } from "@/enums/dialogs";

import { toast } from "@/hooks/use-toast";
import {
  Colis,
  ReturnRequest_,
  ReturnToCreateViaRequest,
} from "@/interfaces/Return";
import { createTourneeViaRequest } from "@/services/return-creation-via-request.service";
import { closeDialog, openDialog } from "@/store/reducers/dialogReducer";
import { setRefreshing } from "@/store/reducers/refreshReducer";
import { RootState } from "@/store/store";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const RequestReturnCreatePage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { returnCode, request, source, dropOff, seller } = useSelector(
    (state: RootState) => state.requestReturnHeader
  );
  const [validatedColis, setValidatedColis] = React.useState<Colis[]>([]);
  const [createLoading, setCreateLoading] = React.useState(false);
  const { isRefreshing } = useSelector((state: RootState) => state.refresh);
  const isOpen = useSelector((state: RootState) => state.dialog.isOpen);

  const handleCreateReturn = async () => {
    if (isOpen === false) {
      dispatch(openDialog(DialogType.REQUEST_RETURN_CREATE_DIALOG));
      return;
    }
    const request_: ReturnRequest_ = {
      sellerId: seller.sellerId,
      headerid: request.num,
    };
    const payload: ReturnToCreateViaRequest = {
      numTournee: returnCode.toString(),
      sellerId: seller.sellerId,
      isSellerVIP: seller.isSellerVIP,
      entityId: dropOff.id,
      demandes: [request_],
      sourceId: source,
    };
    setCreateLoading(true);
    dispatch(closeDialog());
    try {
      const response = await createTourneeViaRequest(payload);
      if (response.status === 200 && response.data.success === true) {
        toast({
          title: "Tournée créée avec succès",
          variant: "success",
        });
        dispatch(setRefreshing(!isRefreshing));
        navigate(NavigationRoutes.DASHBOARD, { replace: true });
      } else {
        setCreateLoading(false);
        toast({
          title: "Erreur lors de la création de la tournée",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Erreur lors de la création de la tournée",
        variant: "destructive",
      });
    } finally {
      setCreateLoading(false);
    }
  };

  const handleCheckValidColis = () => {
    return request.colis.every((c) =>
      validatedColis.some((vc) => vc.colisId === c.colisId)
    );
  };
  return (
    <div className="flex flex-col h-full gap-4">
      <div className="px-4 py-2 flex items-start justify-between gap-2 flex-row ">
        <div className="space-y-1">
          <p className="text-md text-muted-foreground">N° de retour</p>
          <p className="font-semibold">{returnCode && returnCode}</p>
        </div>
        <div className="space-y-1 text-right">
          <p className="text-md text-muted-foreground">Vendeur</p>
          <p className="font-semibold">
            {seller.sellerName && seller.sellerName}
          </p>
        </div>
      </div>
      <ColisScanner
        colis={request.colis}
        scannedColis={validatedColis}
        setScannedColis={setValidatedColis}
      />
      <div className="px-4 flex space-x-4 flex-row">
        <ActionButton
          loading={createLoading}
          disabled={!handleCheckValidColis() || createLoading}
          handleClick={handleCreateReturn}
          label="Valider"
        />
      </div>
      <Toaster />
      <RequestReturnCrationDialog handleValidate={handleCreateReturn} />
    </div>
  );
};

export default RequestReturnCreatePage;
